import axios from 'axios'

// @ts-ignore
axios.defaults.baseURL = window.$HOST

export default axios
